<form *transloco="let t; read: 'inbox-create-callback-note'">
  <label class="flex flex-column gap-2">
    <span>{{ t('noteLabel') }}</span>
    <textarea class="w-full" pInputTextarea rows="6" [formControl]="noteControl"></textarea>
  </label>

  <div class="mt-4 flex justify-content-end">
    <button
      class="p-button-primary"
      pButton
      type="submit"
      [disabled]="noteControl.invalid || saving"
      [label]="t('saveButtonLabel')"
      (click)="saveNoteAndClose()"
    ></button>
  </div>
</form>

<p-toast position="bottom-center"></p-toast>
